export default __webpack_public_path__ + "static/media/education4.6059cf36.jpg";